import React from "react";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import Paginator from "../components/molecules/paginator/Paginator";
import PreviewCard, {
  PreviewCardProps,
} from "../components/molecules/PreviewCard/PreviewCard";
import AsideBar from "../components/organisms/aside/AsideBar";
import GridLayout from "../components/organisms/grid-layout/GridLayout";
import Layout from "../components/organisms/layout/layout";
import LibraryComponents from "../components/templates/library-components/libraryComponents";
import { ReferenciaOrganismos } from "../interfaces/ReferenciaOrganismos";
import SEO from "../shared/seo";
import { dateToRelativeFormat } from "../utils/dateToRelativeFormat";

const TemplateCategoria = (props: any) => {
  const { slug, numPages, currentPage, elements } = props.pageContext;
  const pageData = props.pageContext.pageContent;

  const keyName =
    pageData.referenciaCabecera && pageData.referenciaCabecera.tipoCabecera;
  const pageSlug = props.location.pathname;

  return (
    <Layout
      hideHeaderDesktop={false}
      hideHeaderMobile={false}
      isNotRoot={true}
      headboard={pageData.referenciaCabecera || {}}
      showPlayer={true}
    >
      <SEO
        title={
          props.pageContext.metaTitulo ||
          props.pageContext.pageContent.nombreCategoria
        }
        slug={pageSlug}
        description={
          props.pageContext.metaDescripcion &&
          props.pageContext.metaDescripcion.json.content[0].content[0].value
        }
        lang="es"
      />
      {pageData.referenciaOrganismos &&
        pageData.referenciaOrganismos.map(
          (value: ReferenciaOrganismos, index: number) => (
            <div key={index} className={keyName} id={`${keyName}${index}`}>
              <LibraryComponents
                content={value}
                categoryName={pageData.nombreCategoria}
              />
            </div>
          )
        )}
      <GridLayout columns="2fr 1fr" gap="2rem" padding="1rem 0">
        <div>
          {elements?.map((element, i) => {
            let process: PreviewCardProps = {
              description: element.referenciaInterna.referenciaCabecera?.descripcion?.json?.content[0].content[0].value.slice(
                0,
                180
              ),
              imageUrl:
                element.referenciaInterna.referenciaCabecera.imagenHeader.file
                  .url,
              leftSub: pageData.nombreCategoria,
              link: `${slug}${element.slug}`,
              rightSub: dateToRelativeFormat(element.createdAt),
              title: element.nombreSubcategoria,
            };
            return <PreviewCard {...process} key={i} />;
          })}
        </div>
        <AsideBar />
      </GridLayout>
      <Paginator slug={slug} quantity={numPages} currentPage={currentPage} />
      <Disclaimer />
    </Layout>
  );
};

export default TemplateCategoria;
